import schemas from 'src/modules/shared/yup/yupImporterSchemas';
import { i18n } from 'src/i18n';

export default [
  {
    name: 'nombre',
    label: i18n('entities.categoriaProducto.fields.nombre'),
    schema: schemas.string(
      i18n('entities.categoriaProducto.fields.nombre'),
      {
        "required": true
      },
    ),
  },
  {
    name: 'codigo',
    label: i18n('entities.categoriaProducto.fields.codigo'),
    schema: schemas.string(
      i18n('entities.categoriaProducto.fields.codigo'),
      {},
    ),
  },
];